export const getInitialState = (): any => ({
  trainStatusData: {}
});
